
<template>

    <span class="BlockPaginAnchor"> 

        <component :is="`style`" :key="Key">
            .{{this.m_UniqueClassName}} > {{m_ItemListContainerSelector}} > {{m_ItemListSelector}} > {{m_ItemSelector}}
            {
            width : {{this.m_ItemWidth}} ;
            }


            .{{this.m_UniqueClassName}} > {{m_ItemListContainerSelector}} > {{m_ItemListSelector}}
            {
            width : {{m_BlockItemListWidth}} ;
            display:flex;
            flex-direction:row;
            white-space:nowrap;
            position:relative;
            transition:left 0s;
            }

            .{{this.m_UniqueClassName}} > {{m_ItemListContainerSelector}} > {{m_ItemListSelector}} > {{m_ItemSelector}}
            {
                display:flex;
                align-items: center;
                justify-content: center;
            }

            .{{this.m_UniqueClassName}} > {{m_ItemListContainerSelector}} > {{m_ItemListSelector}}:not(.NoTransition){
            transition:left 0.3s;
            }

            @media screen and (max-width:860px){
            .{{this.m_UniqueClassName}} > {{m_ItemListContainerSelector}} > {{m_ItemListSelector}}
            {
            width : {{m_BlockItemList860Width}} ;
            }
            }

            @media screen and (max-width:660px){
            .{{this.m_UniqueClassName}} > {{m_ItemListContainerSelector}} > {{m_ItemListSelector}}
            {
            width : {{m_BlockItemList660Width}} ;
            }
            }

            @media screen and (max-width:440px){
            .{{this.m_UniqueClassName}} > {{m_ItemListContainerSelector}} > {{m_ItemListSelector}}
            {
            width : {{m_BlockItemList440Width}} ;
            }
            }
        </component>
    </span>

</template>

<script scoped>
    import Utility from '@/Common/Utility' 
    import PlugableControlBase from "@/Common/PlugableControlBase"
    import TouchEventManager from '@/Common/TouchEventManager'
 


    export default {
        name: "BlockPagingAnchor",
        data() {
            return {
                Key : 0,
                ControlId: "",

                m_HasPreparePagingButton:false,
                m_SourcePageIndex : 0, 
                m_RecordPerItem : 1 ,

                m_SourceTargetListLength : 0,
                m_TargetList : [],

                m_HasPlay: false ,
                m_AutoPlay: false,
                m_Duration: 5, //5 秒
                m_PlayTimer: null,


                m_UniqueClassName :"" ,
                m_PagingBlockElement: null,
                m_ItemListContainerElement: null,
                m_ItemListElement: null,
                m_PaginationElement: null,
                m_ShowPagingButton: true,
                m_ShowPaginationButton: true,

                m_PaginationButtonRender: null,
                m_HoverToPicture: false,//當滑鼠移至 PaginationButton 要顯示 對應的 圖片

                m_ItemPerPage:4,
                m_MobileItemPerPage: 1,
                m_PlayMode: "Normal",//Normal , Loop

                m_Moving: false,
                m_Touching: false,

                m_TouchStartX: 0,
                m_LastPlayPageIndex: 0,
                m_LastPlayPageCount:1,
                m_LastBrowserWidth: 1000,

                m_ItemList : [] ,
                m_PagingBlockSelector: "",
                m_ItemListContainerSelector: "",
                m_ItemListSelector: "",
                m_ItemSelector: "DIV",

                m_PrevButtonElement: null,
                m_NextButtonElement: null,

                m_ItemWidth: "100%",

                m_BlockItemListWidth: "100%",

                m_BlockItemList860Width: "100%",

                m_BlockItemList660Width: "100%",

                m_BlockItemList440Width: "100%",

                m_CheckingResize: false,

                m_LastAppendTime: new Date("1990/1/1"),

                count: 0
            }
        }
        ,

        props: ["value", "name",
            "PagingBlockSelector",
            "ItemListContainerSelector",
            "ItemListSelector",
            "ItemSelector",
            "ItemList",
            "TargetList" ,
            "ItemPerPage",
            "MobileItemPerPage",
            "PlayMode",
            "PaginationButtonRender",
            "HoverToPicture",
            "ShowPagingButton",
            "ShowPaginationButton",
            "AutoPlay",
            "Duration"
        ],


        methods: {

            Build() {
                this.SetPagingStyle();
                this.BindEvents();         

                if (this.AutoPlay) {
                    this.Play();
                }
            },





            OnResize() {
                let browserWidth;
                if (!this.m_CheckingResize) {
                    browserWidth = Utility.GetBrowserWidth();

                    if (this.m_LastBrowserWidth != browserWidth) {
                        this.m_CheckingResize = true;

                        this.MoveToSourcePage(0, true);

                        setTimeout(
                            this.DelayCheckResize.bind(this),
                            500
                        );
                    }
                }
            },


            DelayCheckResize() {
                this.SetPagingStyle();

                if (this.m_PaginationElement != null) {
                    this.m_PaginationElement.remove();


                    if (this.m_ShowPaginationButton) {
                        this.PreparePagination();
                    }

                    setTimeout(
                        () => {
                            Utility.ResetImagesOrientation(this.m_PagingBlockElement);
                        },
                        10
                    );
                }

                this.m_CheckingResize = false;
            } ,


            //#region 移動到前一頁
            OnPreviousButtonClick(e) {

                if (!this.m_Moving) { 
                    this.MoveToPreviousPage();
                }
            },
            //#endregion


            //#region 移動到下一頁
            OnNextButtonClick(e) {

                if (!this.m_Moving) {
                    this.MoveToNextPage();

               
                }
            },
            //#endregion

            Play() {
                if (!this.m_Moving) {

                    if (this.m_HasPlay == false) {
                        //Do Nothing
                    }
                    else {
                        if (
                            (this.m_PlayMode == "Normal") &&
                            (this.GetCurrentPlayPageIndex() == this.TargetList.length - 1)
                        ) {
                            this.MoveToSourcePage(0);
                        }
                        else {
                            this.MoveToNextPage();
                        }
                    }

                    if (this.m_AutoPlay == true) {
                        this.m_PlayTimer = setTimeout(
                            this.Play.bind(this),
                            this.m_Duration * 1000
                        );
                    }

                    this.m_HasPlay = true;
                }
                else {
                    if (this.m_PlayTimer != null) {
                        clearTimeout(this.m_PlayTimer);
                    }

                    if (this.m_AutoPlay == true) {
                        this.m_PlayTimer = setTimeout(
                                                this.Play.bind(this),
                                                1000
                                            );
                    }
                }
            } ,

            OnTouchMoveToPrevious() {
         
                this.MoveToPreviousPage();

            },

            OnTouchMoveToNext() {
                this.MoveToNextPage();
            },



            OnTouchStart(e, options) {

                this.m_LastPlayPageIndex = this.GetCurrentPlayPageIndex();
                this.m_LastPlayPageCount = this.GetCurrentPlayPageCount();

                this.m_TouchStartX = window.getComputedStyle(this.m_ItemListElement).getPropertyValue("left");

                this.m_TouchStartX = new Number(this.m_TouchStartX.replace("px", ""));

                this.m_TouchingClassName = "Touching";
            },


            OnTouchMove(e, options) {
                //e.preventDefault();

                this.m_ItemListElement.style.left =
                    (this.m_TouchStartX + options.MoveX) + "px";
            },


            OnTouchEnd(e, options) {
                let threshold = 0.2;
                let playPageIndex = 0,playPageCount = 1;
                let sourcePageIndex;



                this.m_TouchingClassName = "TouchingChange";

                if (this.$el.clientWidth > 660) {
                    threshold = 0.2;
                }

                if (
                    (
                        Math.abs(options.MoveX) / this.m_ItemListContainerElement.clientWidth
                    ) > threshold
                ) {

                    //有移動
                    if (options.MoveX > 0) {
                        //要往前一頁

                        if (this.m_PlayMode == "Normal") {
                            if (this.m_LastPlayPageIndex > 0) {
                                this.MoveToPlayPage(this.m_LastPlayPageIndex - 1);

                                sourcePageIndex = this.GetSourcePageByPlayPageIndex(this.m_LastPlayPageIndex - 1);


                                this.SetPaginationButtonStyle(sourcePageIndex);
                                this.SetPagingButtonStyle(sourcePageIndex);

                                this.$emit("change", sourcePageIndex);
                                this.$emit("input", sourcePageIndex);


                            }
                            else {
                                //回到原本頁面
                                this.MoveToPlayPage(0);

                                sourcePageIndex = 0;

                                this.$emit("change", sourcePageIndex);
                                this.$emit("input", sourcePageIndex);
                            }
                        }
                        else { //Loop

                            if (this.m_LastPlayPageIndex > 1) {
                                this.MoveToPlayPage(this.m_LastPlayPageIndex - 1);

                                sourcePageIndex = this.GetSourcePageByPlayPageIndex(this.m_LastPlayPageIndex - 1);
                                this.SetPaginationButtonStyle(sourcePageIndex);
                                this.SetPagingButtonStyle(sourcePageIndex);

                                this.$emit("change", sourcePageIndex);
                                this.$emit("input", sourcePageIndex);
                            }
                            else {
                                this.MoveToPlayPage(0);

                                this.SetPaginationButtonStyle(this.m_LastPlayPageCount - 2 -1);

                                setTimeout(
                                    function () {
                                        this.MoveToPlayPage(this.m_LastPlayPageCount - 2,true);


                                        sourcePageIndex = this.GetSourcePageByPlayPageIndex(this.m_LastPlayPageCount - 2);
                                        this.SetPagingButtonStyle(sourcePageIndex);


                                        this.$emit("change", sourcePageIndex);
                                        this.$emit("input", sourcePageIndex);
                                    }.bind(this),
                                    300
                                );                               
                            }
                        }

                    }
                    else {
                        //要往下一頁
                        if (this.PlayMode == "Normal") {
                            if (this.m_LastPlayPageIndex < this.m_LastPlayPageCount - 1) {

                                this.MoveToPlayPage(this.m_LastPlayPageIndex + 1);

                                sourcePageIndex = this.GetSourcePageByPlayPageIndex(this.m_LastPlayPageIndex + 1);
                                this.SetPaginationButtonStyle(sourcePageIndex);
                                this.SetPagingButtonStyle(sourcePageIndex);

                                this.$emit("change", sourcePageIndex);
                                this.$emit("input", sourcePageIndex);
                            }
                            else {
                                this.MoveToPlayPage(this.m_LastPlayPageIndex);

                                sourcePageIndex = this.GetSourcePageByPlayPageIndex(this.m_LastPlayPageIndex);

                                this.SetPaginationButtonStyle(sourcePageIndex);
                                this.SetPagingButtonStyle(sourcePageIndex);

                                this.$emit("change", sourcePageIndex);
                                this.$emit("input", sourcePageIndex);
                            }
                        }
                        else {
                            if (this.m_LastPlayPageIndex < this.m_LastPlayPageCount - 2) {

                                this.MoveToPlayPage(this.m_LastPlayPageIndex + 1);

                                sourcePageIndex = this.GetSourcePageByPlayPageIndex(this.m_LastPlayPageIndex + 1);

                                this.SetPaginationButtonStyle(sourcePageIndex);
                                this.SetPagingButtonStyle(sourcePageIndex);

                                this.$emit("change", sourcePageIndex);
                                this.$emit("input", sourcePageIndex);
                            }
                            else {
                                this.MoveToPlayPage(this.m_LastPlayPageIndex + 1);

                                this.$emit("change", 0);
                                this.$emit("input", 0);
                                this.SetPaginationButtonStyle(0);
                                this.SetPagingButtonStyle(0);

                                setTimeout(
                                    function () {
                                        this.MoveToPlayPage(1, true);


                                    }.bind(this),
                                    300
                                );
                            }
                        }
                    }
                }
                else {
                    //this.MoveToPage(this.m_PageIndex);

                    this.MoveToPlayPage(this.m_LastPlayPageIndex);
                }

                this.StayDuration = 0;

                setTimeout(
                    () => {
                        this.m_TouchingClassName = "";
                    },
                    500
                );
            },


            OnPaginationButtonHover(e, index) {
                let paginationButtonListElement;
                let currButtonElement, buttonElementElements;
                let sourceIndex;
                let i;

                
                paginationButtonListElement = Utility.GetParentElementBySelector(e.target, ".PaginationButtonList");
                currButtonElement = Utility.GetParentElementBySelector(e.target, ".PaginationButton");

                buttonElementElements = paginationButtonListElement.querySelectorAll(".PaginationButton")

                sourceIndex = parseInt(currButtonElement.getAttribute("Index") + "");

                for (i = 0; i < buttonElementElements.length; i++) {
                    if (buttonElementElements[i] != currButtonElement) {
                        buttonElementElements[i].classList.remove("Current");
                    }
                    else {
                        if (!buttonElementElements[i].classList.contains("Current")) {
                            buttonElementElements[i].classList.add("Current");
                        }
                    }
                }

                this.MoveToSourcePage(sourceIndex);
            },


            OnPaginationButtonClick(e,index) {
                let paginationButtonListElement;
                let currButtonElement, buttonElementElements;
                let sourceIndex;
                let i;

                if (this.m_Moving) {
                    return;
                }
                 

                paginationButtonListElement = Utility.GetParentElementBySelector(e.target, ".PaginationButtonList");
                currButtonElement = Utility.GetParentElementBySelector(e.target, ".PaginationButton");

                buttonElementElements = paginationButtonListElement.querySelectorAll(".PaginationButton")

                sourceIndex = parseInt(currButtonElement.getAttribute("Index") +"");
                
                for (i = 0; i < buttonElementElements.length; i++) {
                    if (buttonElementElements[i] != currButtonElement) {
                        buttonElementElements[i].classList.remove("Current");
                    }
                    else {
                        if (!buttonElementElements[i].classList.contains("Current")){
                            buttonElementElements[i].classList.add("Current");
                        }
                    }
                }
                 
                this.MoveToSourcePage(sourceIndex);
            } ,


            SetPaginationButtonStyle(sourceIndex) {
                let paginationButtonListElement;
                let buttonElementElements;
                let i;


                if (sourceIndex == null) {
                    throw ("sourceIndex is null");
                }

                if (!this.m_ShowPaginationButton) {
                    return;
                }

                paginationButtonListElement = this.m_PagingBlockElement.querySelector(".PaginationButtonList");
                if (paginationButtonListElement != null) {
                    buttonElementElements = paginationButtonListElement.querySelectorAll(".PaginationButton")


                    for (i = 0; i < buttonElementElements.length; i++) {
                        if (i != sourceIndex) {
                            buttonElementElements[i].classList.remove("Current");
                        }
                        else {
                            if (!buttonElementElements[i].classList.contains("Current")) {
                                buttonElementElements[i].classList.add("Current");
                            }
                        }
                    }
                }
               
            },


            //#region SetPagingStyle 設定分頁寬度等樣式
            SetPagingStyle() {
                let pageCount = 1;
                let itemWidth;
                let itemCount;
                let fullItemCount = 0;
                let firstTargetListItem,lastTargetListItem;
                let i;
                 

                this.m_UniqueClassName = "BP_" + Utility.GenerateSerialNumber();

                this.m_PagingBlockSelector = this.PagingBlockSelector;
                this.m_ItemListContainerSelector = this.ItemListContainerSelector;
                this.m_ItemListSelector = this.ItemListSelector;
                this.m_TargetList = this.TargetList;
                this.m_PlayMode = this.PlayMode;

                if (this.MobileItemPerPage != null) {
                    this.m_MobileRecordPerPage = parseInt(this.MobileItemPerPage + "");
                }

                if (this.value != "" && this.value != null) {
                    this.m_SourcePageIndex = parseInt(this.value + "");
                }

                if (
                    this.HoverToPicture != null &&
                    (this.HoverToPicture + "").toLocaleLowerCase() == "true"
                ) {
                    this.m_HoverToPicture = true;
                }
                else {
                    this.m_HoverToPicture = false;
                }

                if (
                    this.ShowPagingButton != null &&
                    (this.ShowPagingButton + "").toLocaleLowerCase() == "false"
                ) {
                    this.m_ShowPagingButton = false;
                }
                else {
                    this.m_ShowPagingButton = true;
                }


                if (
                    this.ShowPaginationButton != null &&
                    (this.ShowPaginationButton + "").toLocaleLowerCase() == "false"
                ) {
                    this.m_ShowPaginationButton = false;
                }
                else {
                    this.m_ShowPaginationButton = true;
                }

                

                if (this.AutoPlay == "true" || this.AutoPlay == true) {
                    this.m_AutoPlay = true;
                }
                else {
                    this.m_AutoPlay = false;
                }

                if (this.Duration != null && !isNaN(this.Duration)) {
                    this.m_Duration = new Number(this.Duration);
                }
                else {
                    this.m_Duration = 5;
                }

                this.m_PaginationButtonRender = this.PaginationButtonRender;

                this.m_LastBrowserWidth  = Utility.GetBrowserWidth();


                if (this.m_PlayMode == "Loop" && this.ItemPerPage != 1) {
                    alert("當 PlayMode 為 Loop , ItemPerPage 只能是 1 ");
                    return;
                }

                if (this.ItemPerPage != null) {
                    this.m_ItemPerPage = parseInt(this.ItemPerPage + "");
                }
                else {
                    this.m_ItemPerPage =4;
                }

                if (this.MobileItemPerPage != null) {
                    this.m_MobileItemPerPage = this.MobileItemPerPage;
                }
                else {
                    this.m_MobileItemPerPage = 1;
                }
                

                this.m_PagingBlockElement = Utility.GetParentElementBySelector(this.$el, this.m_PagingBlockSelector);

                if (this.m_PagingBlockElement == null) {
                    throw ("this.m_PagingBlockElement is null");
                }

                this.m_ItemListContainerElement = this.m_PagingBlockElement.querySelector(this.m_ItemListContainerSelector);
                if (this.m_ItemListContainerElement == null) {
                    throw ("this.m_ItemListContainerElement is null");
                }

                this.m_ItemListElement = this.m_ItemListContainerElement.querySelector(this.m_ItemListSelector);
                if (this.m_ItemListElement == null) {
                    throw ("this.m_ItemListElement is null");
                }

                if (this.ItemSelector != null) {
                    this.m_ItemSelector = this.ItemSelector;
                }
                else {
                    this.m_ItemSelector = "DIV";
                }

                this.m_UniqueClassName = "BP_" + Utility.GenerateSerialNumber();

                for (i = this.m_PagingBlockElement.classList.length - 1; i >= 0; i--) {
                    let className = this.m_PagingBlockElement.classList[i];

                    if (className.indexOf("BP_") == 0) {
                        this.m_PagingBlockElement.classList.remove(className);
                    }
                }

                if (!this.m_PagingBlockElement.classList.contains(this.m_UniqueClassName)) {
                    this.m_PagingBlockElement.classList.add(this.m_UniqueClassName);
                }



                if (this.TargetList.length == 0) {
                    return;
                }

                if (this.m_SourceTargetListLength == 0) {
                    this.m_SourceTargetListLength = this.TargetList.length;

                    if (this.m_PlayMode == "Loop") {
                        firstTargetListItem = this.TargetList[0];
                        lastTargetListItem = this.TargetList[this.TargetList.length - 1];

                        this.TargetList.splice(0, 0, lastTargetListItem);
                        this.TargetList.push(firstTargetListItem);

                        this.m_LastAppendTime = new Date();
                    }

                    this.Key++;
                }

                itemCount = this.m_TargetList.length;

                //#region 設定寬度 CSS 樣式

                this.m_ItemWidth = (Math.round(100 * 100 / this.m_TargetList.length) / 100) + "%";
                 
                pageCount = Math.ceil(this.m_TargetList.length / this.m_ItemPerPage);
                fullItemCount = pageCount * this.m_ItemPerPage;

                this.m_BlockItemListWidth = ((pageCount * 100) * (itemCount / fullItemCount)) + "%";

                 
                if (this.m_MobileRecordPerPage == null) {
                    if (this.m_ItemPerPage >= 2) {
                        pageCount = Math.ceil(this.m_TargetList.length / 2);
                        fullItemCount = pageCount * 2;
                    }
                    else {
                        pageCount = this.m_TargetList.length / 1;
                        fullItemCount = pageCount * 1;
                    }

                    this.m_BlockItemList860Width = ((pageCount * 100) * (itemCount / fullItemCount)) + "%";

                    pageCount = this.TargetList.length / 1;
                    fullItemCount = pageCount * 1;

                    this.m_BlockItemList660Width = ((pageCount * 100) * (itemCount / fullItemCount)) + "%";
                    this.m_BlockItemList440Width = this.m_BlockItemList660Width;
                }
                else {
                    pageCount = Math.ceil(this.m_TargetList.length / this.m_MobileRecordPerPage);
                    fullItemCount = pageCount * this.m_MobileRecordPerPage;

                    this.m_BlockItemList860Width = ((pageCount * 100) * (itemCount / fullItemCount)) + "%";

                    this.m_BlockItemList660Width = this.m_BlockItemList860Width;
                    this.m_BlockItemList440Width = this.m_BlockItemList660Width;
                }
                //#endregion


                
                if (this.m_PlayMode == "Loop") {
                    if (this.m_TargetList.length > 0) {
                        this.MoveToPlayPage(1, true);
                    }
                }
                else {
                    if (this.m_TargetList.length > 0) {
                        this.MoveToPlayPage(this.m_SourcePageIndex, true);
                    } 
                }

                setTimeout(
                    () => {
                        if (this.m_TargetList.length > 0) {
                            this.MoveToSourcePage(this.m_SourcePageIndex, true);
                        }
                    },
                    100
                );

                this.$forceUpdate();
            },
            //#endregion



            //#region BindEvents 綁定事件 , 在 Resize 的時候 不需要呼叫此 Method
            BindEvents() {
                this.m_TouchEventManager = new TouchEventManager();

                if (this.m_ShowPagingButton == true) {
                    if (this.m_HasPreparePagingButton == false) {
                        this.m_HasPreparePagingButton = true;
                        this.PreparePagingButton();
                    }
                }

                if (this.m_ItemListContainerElement.clientWidth > 100) {
                    setTimeout(
                        () => {
                            if (this.m_ShowPaginationButton) {
                                this.PreparePagination();
                            }
 
                            this.SetPagingButtonStyle(0);
                        },
                        10
                    );

                }
                else {
                    setTimeout(
                        () => {
                            if (this.m_ShowPaginationButton) {
                                this.PreparePagination();
                            }
                            this.SetPagingButtonStyle(0);
                        },
                        500
                    );
                }

                this.m_TouchEventManager.Attach(this.m_ItemListContainerElement);
      
                this.m_TouchEventManager.TouchStartHandler = this.OnTouchStart;
                this.m_TouchEventManager.TouchMoveHandler = this.OnTouchMove;
                this.m_TouchEventManager.TouchEndHandler = this.OnTouchEnd;

                window.addEventListener("resize", this.OnResize.bind(this));
            },
            //#endregion

            //#region 前一頁 下一頁 分頁按鈕
            PreparePagingButton() {
                let pagingButtonElement;

                if (this.m_ItemListContainerElement.querySelector(".PagingButton.Previous") == null) { 
                    pagingButtonElement = document.createElement("DIV");

                    pagingButtonElement.classList.add("PagingButton");
                    pagingButtonElement.classList.add("Previous");

                    this.m_ItemListContainerElement.insertAdjacentElement("BeforeBegin", pagingButtonElement);
                }

                if (this.m_ItemListContainerElement.querySelector(".PagingButton.Next") == null) {
                    pagingButtonElement = document.createElement("DIV");

                    pagingButtonElement.classList.add("PagingButton");
                    pagingButtonElement.classList.add("Next");

                    this.m_ItemListContainerElement.insertAdjacentElement("AfterEnd", pagingButtonElement);
                }

                setTimeout(
                    function () {
                        this.m_PrevButtonElement = this.m_ItemListContainerElement.parentElement.querySelector(".PagingButton.Previous");
                        this.m_NextButtonElement = this.m_ItemListContainerElement.parentElement.querySelector(".PagingButton.Next");


                        if (!Utility.IsMobile()) {
                            this.m_PrevButtonElement.addEventListener(
                                "click",
                                this.OnPreviousButtonClick.bind(this)
                            );

                            this.m_NextButtonElement.addEventListener(
                                "click",
                                this.OnNextButtonClick.bind(this)
                            );
                        }
                        else {
                            this.m_PrevButtonElement.addEventListener(
                                "touchstart",
                                this.OnPreviousButtonClick.bind(this)
                            );

                            this.m_NextButtonElement.addEventListener(
                                "touchstart",
                                this.OnNextButtonClick.bind(this)
                            );
                        }

                    

                        this.m_NextButtonElement.addEventListener(
                            "click",
                            this.OnNextButtonClick.bind(this)
                        );
                    }.bind(this),
                    1
                );
            },
            //#endregion


            //#region 準備分頁索引按鈕
            PreparePagination() {
                let paginationElement = null;
                let buttonListElement = null;
                let buttonElement = null;
                let buttonCount = 0;
                let pageCount,sourcePgaeCount;
                let i;


                if (this.m_ItemListElement == null) {
                    return;
                }

                if (this.m_PagingBlockElement.querySelector(".Pagination") == null) {
                    paginationElement = document.createElement("DIV");
                    paginationElement.classList.add("Pagination");

                    this.m_PaginationElement = paginationElement;

                    buttonListElement = document.createElement("DIV");
                    buttonListElement.classList.add("PaginationButtonList");

                    paginationElement.insertAdjacentElement("AfterBegin", buttonListElement);

                    pageCount = this.GetCurrentPlayPageCount();

                    
                    if (this.m_PlayMode == "Normal") {
                        sourcePgaeCount = pageCount;
                    }
                    else {
                        sourcePgaeCount = pageCount- 2;
                    }
                     
                    for (i = 0; i < sourcePgaeCount ; i++) {
                        buttonElement = document.createElement("DIV");
                        buttonElement.classList.add("PaginationButton");

                        if (i == 0) {
                            buttonElement.classList.add("Current");
                        }

                       
                        if (this.m_PaginationButtonRender != null) {
           
                            let buttonHtml;
                            let playPageIndex;

                            if (this.PlayMode == "Normal") {
                                playPageIndex = i;
                            }else {
                                playPageIndex = i+1;
                            }

                            buttonHtml = this.m_PaginationButtonRender(this.TargetList[playPageIndex], playPageIndex);

                            buttonElement.insertAdjacentHTML("AfterBegin", buttonHtml);
                        }
                        else {
                            buttonElement.insertAdjacentHTML("AfterBegin", `<div>${(i + 1)}</div>`);
                        }

                        buttonListElement.appendChild(buttonElement);
                        buttonElement.setAttribute("Index", i);

                        if (this.m_HoverToPicture == true) {
                            buttonElement.addEventListener("mouseover", this.OnPaginationButtonHover.bind(this))
                        }

                        buttonElement.addEventListener("click", this.OnPaginationButtonClick.bind(this))
                    }

                    if (pageCount == 1) {
                        paginationElement.classList.add("OnlyOne");
                    }

                    this.m_PagingBlockElement.appendChild(paginationElement);
                }
            },
            //#endregion



            SetPagingButtonStyle(sourcePageIndex) {
                let playPageIndex, playPageCount;


                if (!this.m_ShowPagingButton) {
                    return;
                }

                if (this.m_ItemListElement == null) {
                    return;
                }

                playPageCount = this.GetCurrentPlayPageCount();
                playPageIndex = this.GetCurrentPlayPageIndex();

                if (this.PlayMode == "Normal") {
                    //#region PrevButtonElement

                    if (sourcePageIndex == null) {
                        sourcePageIndex = playPageIndex;
                    }

                    if (sourcePageIndex == 0) {
                        if (!this.m_PrevButtonElement.classList.contains("Disabled")) {
                            this.m_PrevButtonElement.classList.add("Disabled");
                        }   
                    }
                    else {
                        this.m_PrevButtonElement.classList.remove("Disabled");
                    }
                    //#endregion

                    //#region m_NextButtonElement
                    if (sourcePageIndex == playPageCount - 1) {
                        if (!this.m_NextButtonElement.classList.contains("Disabled")) {
                            this.m_NextButtonElement.classList.add("Disabled");
                        }
                    }
                    else {
                        this.m_NextButtonElement.classList.remove("Disabled");
                    }
                    //#endregion

                }
                else {
                    this.m_PrevButtonElement.classList.remove("Disabled");
                    this.m_NextButtonElement.classList.remove("Disabled");
                }
            } ,

            MoveToSourcePage(sourcePageIndex, moveDirectly) {

                if (this.m_PlayMode == "Normal") {
                    this.MoveToPlayPage(sourcePageIndex, moveDirectly);
                }
                else {
                    this.MoveToPlayPage(sourcePageIndex + 1, moveDirectly);
                }

                this.SetPaginationButtonStyle(sourcePageIndex, moveDirectly);
                this.SetPagingButtonStyle(sourcePageIndex);

                this.$emit("change", sourcePageIndex);
                this.$emit("input", sourcePageIndex);
            },


            MoveToPreviousPage() {
                let pageIndex, pageCount;
                let sourceIndex;

                pageIndex = this.GetCurrentPlayPageIndex();
                pageCount = this.GetCurrentPlayPageCount();
 

                if (this.m_PlayMode == "Normal") {
                    if (pageIndex > 0) {
                        this.MoveToPlayPage(pageIndex - 1);

                        sourceIndex = this.GetSourcePageByPlayPageIndex(pageIndex - 1);

                        this.SetPaginationButtonStyle(sourceIndex);
                        this.SetPagingButtonStyle(sourceIndex);

                        this.$emit("change", sourceIndex);
                        this.$emit("input", sourceIndex);
                    }
                }
                else {
                    //Loop
                    if (pageIndex > 0) {
                        this.MoveToPlayPage(pageIndex - 1);
                    }

                    if ((pageIndex - 1) <= 0) {
                        //如果已經移到了第一頁
                        //則快速回到第 PageCount -1 頁
                        this.m_Moving = true;

                        setTimeout(
                            function () {
                                this.MoveToPlayPage(pageCount - 2, true);
                                this.m_Moving = false;
                            }.bind(this),
                            500
                        );

                        sourceIndex = this.GetSourcePageByPlayPageIndex(pageCount - 2);
 
                        this.SetPaginationButtonStyle(sourceIndex);
                        this.SetPagingButtonStyle(sourceIndex);

                        this.$emit("change", sourceIndex);
                        this.$emit("input", sourceIndex);
                    }
                    else { 
                        sourceIndex = this.GetSourcePageByPlayPageIndex(pageIndex - 1);
 

                        this.SetPaginationButtonStyle(sourceIndex);
                        this.SetPagingButtonStyle(sourceIndex);
 
                        this.$emit("change", sourceIndex);
                        this.$emit("input", sourceIndex);
                    }
                }
                 
            },


            MoveToNextPage() {
                let pageIndex, pageCount;
                let sourceIndex;
                 

                pageIndex = this.GetCurrentPlayPageIndex();
                pageCount = this.GetCurrentPlayPageCount();
                 
                if (this.m_PlayMode == "Normal") {
                    if (pageIndex < pageCount - 1) {
                        this.MoveToPlayPage(pageIndex + 1);

                        sourceIndex = this.GetSourcePageByPlayPageIndex(pageIndex + 1);

                        this.SetPaginationButtonStyle(sourceIndex);
                        this.SetPagingButtonStyle(sourceIndex);

                        this.$emit("change", sourceIndex);
                        this.$emit("input", sourceIndex);
                    }
                }
                else {
                    //Loop
                    if (pageIndex < pageCount - 1) {
                        this.MoveToPlayPage(pageIndex+1);
                    }

                    if ((pageIndex + 1) == (pageCount - 1)) {
                        //如果已經移到了最後一頁
                        //則快速回到第 Index = 1 頁
                        this.m_Moving = true;

                        setTimeout(
                            function () {
                                this.MoveToPlayPage(1, true);
                                this.m_Moving = false;
                            }.bind(this),
                            400
                        );

                        sourceIndex = this.GetSourcePageByPlayPageIndex(1);
                        this.SetPaginationButtonStyle(sourceIndex);
                        this.SetPagingButtonStyle(sourceIndex);

                        this.$emit("change", sourceIndex);
                        this.$emit("input", sourceIndex);
                    }
                    else {
                        sourceIndex = this.GetSourcePageByPlayPageIndex(pageIndex + 1);
                        this.SetPaginationButtonStyle(sourceIndex);
                        this.SetPagingButtonStyle(sourceIndex);

                        this.$emit("change", sourceIndex);
                        this.$emit("input", sourceIndex);
                    }
                }

                  
            },


            GetSourcePageByPlayPageIndex(playPageIndex) {
                let sourceIndex = playPageIndex;

                if (this.PlayMode == "Normal") {
                    sourceIndex = playPageIndex
                }
                else {
                    if (playPageIndex == 0) {
                        sourceIndex = this.TargetList.length - 2 - 1;
                    }
                    else if (playPageIndex == this.TargetList.length - 1) {
                        sourceIndex = 0;
                    }
                    else {
                        sourceIndex = playPageIndex - 1;
                    }
                }

                return sourceIndex;
            } ,

            GetCurrentPlayPageCount() {
                let pageCount = 0;

                if (this.m_ItemPerPage > 1) {
                    pageCount = Math.ceil(
                        this.m_ItemListElement.clientWidth /
                        this.m_ItemListContainerElement.clientWidth
                    );
                }
                else { 
                    pageCount = this.TargetList.length;
                }

                return pageCount;
            },


            GetCurrentPlayPageIndex() {
                let pageIndex = 0;
                let left;
                let containerWidth;

                left = window.getComputedStyle(this.m_ItemListElement).getPropertyValue("left");

                left = new Number(left.replace("px", ""));
                containerWidth = this.m_ItemListContainerElement.clientWidth;

                pageIndex = Math.abs(Math.round(left / containerWidth));

                return pageIndex;
            },


            GetCurrentItemPerPage() {
                let itemPerPage = this.m_ItemPerPage;
                let itemWidth;
                let containerWidth;

                if (this.m_ItemListElement.children.length > 0) {
                    itemWidth = this.m_ItemListElement.children[0].clientWidth;
                    containerWidth = this.m_ItemListContainerElement.clientWidth;

                    itemPerPage = Math.round(containerWidth / itemWidth);
                }


                return itemPerPage;
            },


            MoveToPlayPage(pageIndex, moveDirectly) {

                if (this.m_ItemListElement == null) {
                    console.log("this.m_ItemListElement == null");
                    return;
                }

                if (moveDirectly == true) {
                    if (moveDirectly == true) {
                        this.m_ItemListElement.classList.add("NoTransition");
                    }

                    this.m_ItemListElement.style.left = -(pageIndex * 100) + "%";

                    this.m_Moving = true;
                     setTimeout(
                         function () { 

                             this.m_ItemListElement.classList.remove("NoTransition");

                             this.m_Moving = false;
                        }.bind(this)
                    ),
                    400
                 }
                else {
                    this.m_ItemListElement.style.left = -(pageIndex * 100) + "%";
                }
            },


            Release() {

                if (this.m_ItemListElement != null) {
                    this.m_ItemListElement.style.left = "";
                }

                this.m_HasPlay = false;
                this.m_AutoPlay = false;
                this.m_Duration = 5;

                if (this.m_PlayTimer != null) {
                    clearTimeout(this.m_PlayTimer);
                }

                this.m_PlayTimer = null;

                this.m_ItemListContainerSelector = null;
                this.m_ItemListSelector = null;
                this.m_ItemListContainerElement = null;
                this.m_ItemListElement = null;
                this.m_PlayMode = "Normal";
                this.m_ShowPagingButton = true;
                this.m_ShowPaginationButton = true;
                this.m_HoverToPicture = false;
                this.m_TouchEventManager.Detach();

                this.m_TouchEventManager = null;

                if (this.m_PrevButtonElement != null) {
                    this.m_PrevButtonElement.removeEventListener(
                        "click",
                        this.OnPreviousButtonClick.bind(this)
                    );
                    this.m_PrevButtonElement.removeEventListener(
                        "touchstart",
                        this.OnPreviousButtonClick.bind(this)
                    );
                    this.m_PrevButtonElement.remove();

                }

                if (this.m_NextButtonElement != null) {
                    this.m_NextButtonElement.removeEventListener(
                        "click",
                        this.OnNextButtonClick.bind(this)
                    );
                    this.m_NextButtonElement.removeEventListener(
                        "touchstart",
                        this.OnNextButtonClick.bind(this)
                    );
                    this.m_NextButtonElement.remove();
                }

                if (this.m_PaginationElement != null) {
                    this.m_PaginationElement.remove();
                }


                this.m_PaginationButtonRender = null;
                this.m_PagingBlockElement.classList.remove(this.m_UniqueClassName);
                window.removeEventListener("resize", this.OnResize.bind(this));

            } ,

        },

        beforeMount() {
        },




        mounted() { 

            //繼承 PlugableControlBase
            PlugableControlBase.call(this);

            this.Build();
        },


        beforeMounted() {

        },

        beforeDestroy() {
            this.Release();


            this.m_Destroyed = true;
        },

        components: {
        },

        created() {

        },

        watch: {

            ItemListContainerSelector: function (newVal, oldVal) {
                console.log("ItemListContainerSelector Change");
            },

            TargetList: function (newVal, oldVal) {
                let currDate = new Date();

                if (currDate - this.m_LastAppendTime > 100) {
                    //console.log("TargetList Change");

                    this.Release();
                    this.Build();
                }
            },

            value: function (newVal, oldVal) {

                this.m_SourcePageIndex = parseInt(newVal + "");
                this.MoveToSourcePage(this.m_SourcePageIndex);
            },
        },

        computed: {

        }


    }
</script>

<style scoped>

    .BlockPaginAnchor
    {
        display:initial;
    }
</style>
